export const CheckEmpyInput = () => {
  const fields = document.querySelectorAll(".check-empty-filed");

  fields.forEach(el => {
    const checkValue = () => el.classList.toggle("empty", !el.value);
    checkValue();
    el.addEventListener("input", () => checkValue());
  });
};
